import React from 'react';
import componentStyles from './registrationSuggestionCard.module.css';
import globalStyles from '../globals.module.css';
import eventBus from '../../service/eventBus';
import { EVENT_UPDATE_ACTION_BAR_VIEW } from '../../utils/constants';
import { FaUserPlus, FaLock, FaChartLine, FaBell } from 'react-icons/fa';
import AnalyticsService from '../../service/analyticsService';
import { EVENT_REGISTRATION_CTA_CLICKED } from '../../utils/analyticsConstants';

const RegistrationSuggestionCard = ({
    title = 'Unlock Full Access',
    subtitle = 'Sign up to get unlimited access to all betting insights and analysis',
    primaryLabel = 'Sign Up Now',
    primaryView = 'register',
    secondaryLabel = 'Already have an account? Login',
    secondaryView = 'login',
    ctaContext = 'register',
    icon = null
}) => {
    const handleRegisterClick = () => {
        AnalyticsService.getInstance().track(EVENT_REGISTRATION_CTA_CLICKED, { cta: ctaContext, targetView: primaryView });
        eventBus.emit(EVENT_UPDATE_ACTION_BAR_VIEW, primaryView);
    };

    const handleLoginClick = () => {
        AnalyticsService.getInstance().track(EVENT_REGISTRATION_CTA_CLICKED, { cta: ctaContext, targetView: secondaryView });
        eventBus.emit(EVENT_UPDATE_ACTION_BAR_VIEW, secondaryView);
    };

    return (
        <div className={`${componentStyles.registrationCard} ${globalStyles.slight3dEffect}`}>
            <div className={componentStyles.registrationHeader}>
                <div className={componentStyles.registrationIcon}>
                    {icon || <FaUserPlus />}
                </div>
                <h3 className={componentStyles.registrationTitle}>{title}</h3>
                <p className={componentStyles.registrationSubtitle}>
                    {subtitle}
                </p>
            </div>
            
            {/* <div className={componentStyles.benefitsList}>
                <div className={componentStyles.benefitItem}>
                    <div className={componentStyles.benefitIcon}>
                        <FaChartLine />
                    </div>
                    <div className={componentStyles.benefitText}>
                        <span className={componentStyles.benefitTitle}>Advanced Analytics</span>
                        <span className={componentStyles.benefitDescription}>Get detailed scouting reports and predictions</span>
                    </div>
                </div>
                
                <div className={componentStyles.benefitItem}>
                    <div className={componentStyles.benefitIcon}>
                        <FaLock />
                    </div>
                    <div className={componentStyles.benefitText}>
                        <span className={componentStyles.benefitTitle}>Premium Content</span>
                        <span className={componentStyles.benefitDescription}>Access exclusive betting insights and strategies</span>
                    </div>
                </div>
                
                <div className={componentStyles.benefitItem}>
                    <div className={componentStyles.benefitIcon}>
                        <FaBell />
                    </div>
                    <div className={componentStyles.benefitText}>
                        <span className={componentStyles.benefitTitle}>Real-time Updates</span>
                        <span className={componentStyles.benefitDescription}>Stay updated with live odds and game changes</span>
                    </div>
                </div>
            </div> */}
            
            <div className={componentStyles.registrationActions}>
                <button 
                    className={globalStyles.primaryButton}
                    onClick={handleRegisterClick}
                >
                    <FaUserPlus /> {primaryLabel}
                </button>
                {secondaryLabel && secondaryView && (
                    <button 
                        className={globalStyles.secondaryButton}
                        onClick={handleLoginClick}
                    >
                        {secondaryLabel}
                    </button>
                )}
            </div>
        </div>
    );
};

export default RegistrationSuggestionCard; 
